import classes from "./Tictac.module.css";
import { useState } from "react";

export default function Tictac() {
  const [display, setDisplay] = useState(["", "", "", "", "", "", "", "", ""]);
  const [value, setValue] = useState(0);
  const [winner, setWinner] = useState(null);

  const items = (key) => {
    const displayValue = value % 2 === 0 ? "X" : "O";
    let items = [...display];
    let item = [...items[key]];
    item = displayValue;
    items[key] = item;
    return items;
  };

  const checkWinner = (array) => {
    if (value > 3) {
      if (
        (array[0] !== "" && array[0] === array[1] && array[1] === array[2]) ||
        (array[3] !== "" && array[3] === array[4] && array[4] === array[5]) ||
        (array[6] !== "" && array[6] === array[7] && array[7] === array[8]) ||
        (array[0] !== "" && array[0] === array[3] && array[3] === array[6]) ||
        (array[0] !== "" && array[0] === array[4] && array[4] === array[8]) ||
        (array[1] !== "" && array[1] === array[4] && array[4] === array[7]) ||
        (array[2] !== "" && array[2] === array[5] && array[5] === array[8]) ||
        (array[2] !== "" && array[2] === array[4] && array[4] === array[6])
      ) {
        setWinner(true);
      }
    }
  };

  const clickHandler = (key, event) => {
    event.preventDefault();

    if (!winner) {
      if (display[key] === "") {
        const array = items(key);
        setDisplay(array, key);
        checkWinner(array);
        setValue(value + 1);
      }
    }
  };

  const onResetHandler = () => {
    setValue(0);
    setWinner(false);
    const reset = ["", "", "", "", "", "", "", "", ""];
    setDisplay(reset);
  };

  const winnerName = winner
    ? value % 2 !== 0
      ? `Player 1 Won`
      : `Player 2 Won`
    : "";

  return (
    <div className={classes.main}>
      <div className={classes.grid}>
        <div
          className={classes["grid-inline"]}
          onClick={(e) => clickHandler(0, e)}
        >
          {display[0]}
        </div>
        <div
          className={classes["grid-inline"]}
          onClick={(e) => clickHandler(1, e)}
        >
          {display[1]}
        </div>
        <div
          className={classes["grid-inline"]}
          onClick={(e) => clickHandler(2, e)}
        >
          {display[2]}
        </div>
        <div
          className={classes["grid-inline"]}
          onClick={(e) => clickHandler(3, e)}
        >
          {display[3]}
        </div>
        <div
          className={classes["grid-inline"]}
          onClick={(e) => clickHandler(4, e)}
        >
          {display[4]}
        </div>
        <div
          className={classes["grid-inline"]}
          onClick={(e) => clickHandler(5, e)}
        >
          {display[5]}
        </div>
        <div
          className={classes["grid-inline"]}
          onClick={(e) => clickHandler(6, e)}
        >
          {display[6]}
        </div>
        <div
          className={classes["grid-inline"]}
          onClick={(e) => clickHandler(7, e)}
        >
          {display[7]}
        </div>
        <div
          className={classes["grid-inline"]}
          onClick={(e) => clickHandler(8, e)}
        >
          {display[8]}
        </div>
      </div>
      {winner ? <div className={classes.text}>{winnerName}</div> : null}
      <button className={classes.button} onClick={onResetHandler}>
        {" "}
        Reset
      </button>
    </div>
  );
}
